import { defaultFill } from '../../utils/constants';
var muiPasswordShow16 = {
    paths: [
        {
            path: 'M8,0.717514421 C12.418278,0.717514421 16,5.71299782 16,6.71751442 C16,7.72203102 12.418278,12.7175144 8,12.7175144 C3.581722,12.7175144 0,7.78599587 0,6.71751442 C0,5.64903298 3.581722,0.717514421 8,0.717514421 Z M8,2.43113747 C5.05448133,2.43113747 1.96362305,6.00519346 1.96362305,6.71751442 C1.96362305,7.42983538 5.05448133,11.0572361 8,11.0572361 C10.9455187,11.0572361 13.9597168,7.38719216 13.9597168,6.71751442 C13.9597168,6.04783669 10.9455187,2.43113747 8,2.43113747 Z M8,3.71751442 C9.65685425,3.71751442 11,5.06066017 11,6.71751442 C11,8.37436867 9.65685425,9.71751442 8,9.71751442 C6.34314575,9.71751442 5,8.37436867 5,6.71751442 C5,5.06066017 6.34314575,3.71751442 8,3.71751442 Z',
            fill: defaultFill,
        },
    ],
    title: 'Show Data',
    width: 16,
    height: 13,
};
var muiPasswordShow = {
    base: muiPasswordShow16,
    smIcon: muiPasswordShow16,
};
export { muiPasswordShow };
//# sourceMappingURL=passwordShow.js.map